import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_MULTIPLE_QRCODE_FLYERS = createFcmDetails('starfish_multiple_qrcode_flyers', {
	owner: 'starfish',
	context: 'Starter Dashboard page',
	import: false,
	description:
		'Enables the multi flyers modal feature that allows the user to choose and download a qrcode flyer from various templates. This fcm takes precedence over this `starfish_qrcode_flyer` fcm which enables the default qrcode flyer button.',
});
